module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-d4370d84227827528092e426b9465108.png";